<template>
    <div class="o-page"
        :class="{'-with-sidebar': !isMobile && myProfile.role!='STAFF'}"
        :data-component-name="$options.name"
    >
    	<div class="o-sidebar -hidden-mobile" v-if="myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER'">
    		<nav class="o-nav -sticky">
				<div class="o-nav-list">
	                <div class="o-nav-list__item" v-for="(item, i) in menuItems" v-bind:key="i"
                        :class="{
                            '-is-expandable': childMenuItems[item.to],
                            '-is-expanded': childMenuItems[item.to] && $route.name == item.to || childMenuItems[item.to] && childMenuItems[item.to].filter((childItem) => childItem.to == $route.name).length > 0
                        }"
                    >

	                    <div v-if="item.name!='splitter'">
                            <router-link class="o-nav__link" :to="{ name: item.to}">{{ item.name }}</router-link>
                        </div>
	                    <div v-else class="o-nav__split"></div>

                        <div v-if="childMenuItems[item.to]" class="o-nav-list__sublist">
                            <div class="o-nav-list__item" :class="{'is-active': $route.name == childItem.to}" v-for="(childItem, j) in childMenuItems[item.to]" v-bind:key="j">
                                <router-link class="o-nav__link" :to="{ name: childItem.to}">{{ childItem.name }}</router-link>
                            </div>
                        </div>
                        
	                </div>
	            </div>
    		</nav>
    	</div>
		<div class="o-page__content">
	        <div class="c-settings__wrap">
	            <router-view
                    :isMobile="isMobile"
                ></router-view>
	        </div>
		</div>
    </div>
</template>
<script>
    import { checkRouterRules } from '@/js/utilities'
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'Settings',
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                // menuItems: [],
                items: [
                    {
                        name: "Mon compte",
                        to: "my-account"
                    },
                    {
                        name: "Mon profil",
                        to: "my-profile"
                    },
                    // {
                    //     name: "Abonnements",
                    //     to: "site-subscription"
                    // },
                    // {
                    //     name: "splitter",
                    // },
                    {
                        name: "Utilisateurs",
                        to: "user-profiles"
                    },
                    {
                        name: "Modifier les utilisateurs",
                        to: "user-profiles",
                        parent: "user-profiles"
                    },
                    // {
                    //     name: "splitter",
                    // },
                    {
                        name: "Types d'absences",
                        to: "absenceTypes",
                        parent: "user-profiles"
                    },
                    {
                        name: "Ressources",
                        to: "resourceslist"
                    },
                    {
                        name: "Modifier les ressources",
                        to: "resourceslist",
                        parent: "resourceslist"
                    },
                    {
                        name: "Types de ressources",
                        to: "resourceTypes",
                        parent: "resourceslist"
                    },
                    {
                        name: "Types d'indisponibilité de ressource",
                        to: "resourceUnavailabilityTypes",
                        parent: "resourceslist"
                    },
                    {
                        name: "Compagnies",
                        to: "companies",
                        parent: "user-profiles"
                    },
                    {
                        name: "Métiers",
                        to: "professions",
                        parent: "user-profiles"
                    },
                    {
                        name: "Compétences",
                        to: "skills",
                        parent: "user-profiles"
                    },
                    {
                        name: "Formations",
                        to: "courses",
                        parent: "user-profiles"
                    },
                    {
                        name: "Clients",
                        to: "customers-settings"
                    },
                    {
                        name: "Clients",
                        to: "customers-settings",
                        parent: "customers-settings"
                    },
                    {
                        name: "Contacts clients",
                        to: "customers-contacts",
                        parent: "customers-settings"
                    },
                    {
                        name: "Hébergements / Hôtels",
                        to: "accommodations"
                    },
                    {
                        name: "Attributs personnalisés",
                        to: "custom-tag-labels"
                    },
                    // {
                    //     name: "Tags personnalisés",
                    //     to: "custom-tags"
                    // },
                    {
                        name: "Quarts de travail",
                        to: "shift-templates"
                    },
                    {
                        name: "Catégories",
                        to: "categories"
                    },
                    // {
                    //     name: "Nouveau projet",
                    //     to: "project-template"
                    // },
                    // {
                    //     name: "splitter",
                    // },
                    // {
                    //     name: "splitter",
                    // },
                    // {
                    //     name: "splitter",
                    // },
                    // {
                    //     name: "splitter",
                    // },
                    {
                        name: "Réglages",
                        to: "general-settings"
                    },
                ]
            }
        },
        mounted(){


            // if (!this.$generalSettings.settings.enableAccommodationModule) {
            //     this.items = this.items.filter((item) => item.to != 'accommodations')
            // } else {
            //     this.items.push(
            //         {
            //             name: "Hébergements / Hôtels",
            //             to: "accommodations"
            //         },
            //     )
            // }
        },
        // watch: {
        //     items: function () {
        //         this.menuItems = [];
        //         this.items.forEach(function (item) {
        //             if (checkRouterRules(item.to, this.$router)) this.menuItems.push(item)
        //         }.bind(this))
        //     },
    // },
        computed: {
            menuItems() {
                let menuItems = [];

                this.items.forEach(function (item) {
                    if (!this.$generalSettings.settings.enableAccommodationModule && item.to == 'accommodations') {
                        return
                    }
                    if (checkRouterRules(item.to, this.$router) && !item.parent) {
                        menuItems.push(item)
                    }
                }.bind(this))

                return menuItems;
            },
            childMenuItems() {
                let childMenuItems = {};

                this.items.forEach(function (item) {
                    if (!this.$generalSettings.settings.enableAccommodationModule && item.to == 'accommodations') {
                        return
                    }
                    if (checkRouterRules(item.to, this.$router) && item.parent) {
                        if (!childMenuItems[item.parent]) childMenuItems[item.parent] = [];
                        childMenuItems[item.parent].push(item)
                    }
                }.bind(this))

                return childMenuItems;
            }
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
        }
    }
</script>
<style lang="scss">
    @import "@/scss/views/Page.scss";
    @import "@/scss/components/form/Form.scss";

    .c-settings__wrap{
        max-width: 900px;
        min-width: 900px;
		@include media("<md") {
            max-width: 100%;
            min-width: 100%;
        }
    }
    .w-1\/3{
        width: 33.3333%;
        
        .-embedded & {
            width: 25%;
            display: flex;
            flex-direction: column;
            & .o-col__inner {
                flex-grow: 1;
            }
        }
    }
    .w-2\/3{
        width: 66.666%;
        padding-left: 40px !important;
        padding-top: 50px;

        .-embedded & {
            width: 75%;
            padding-left: 20px !important;

            .o-form__item.-button {
                margin-bottom: 0;
                min-height: unset;
            }
        }
    }
</style>
